import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import sysend from 'sysend';
import store from './helpers/store';
import Main from './components/main';
import Logger from '../common/logger';
import DOM from '../common/DOM';
import IPC from './helpers/ipc';
import { dispatch } from './helpers/dispatcher';
import Tracker from './genesys/tracker';
import ErrorBoundary from '../common/errorboundary';

let errorsSent = false;

class OPLWCChild {
    constructor() {
        Logger.setDomain('WC CHILD');

        Logger.onError((message, area) => {
            if (!errorsSent) {
                // send error once
                errorsSent = true;
                const state = store.getState();
                Tracker.sendEvent('widgetReportError', {
                    errorType: area + 'Exception',
                    errorEvent: 'EngagementAttempt',
                    errorInfo: message,
                    errorLayerMode: state.widget ? state.widget.currentMode : ''
                });
            }
        });

        Logger.log('Start: starting child widget...');

        this.messageHandler = this.messageHandler.bind(this);
        IPC.onEvent(this.messageHandler);

        this.embed();

        sysend.on('oplwidget', (message) => {
            Logger.log('Broadcast received: ' + JSON.stringify(message));
            this.messageHandler(message);
        });
    }

    embed() {
        DOM.onWindowLoad(() => {
            IPC.sendReady();
            ReactDOM.render(
                <ErrorBoundary>
                    <Provider store={store}>
                        <Main />
                    </Provider>
                </ErrorBoundary>,
                document.getElementById('child')
            );
        });
    }

    messageHandler(message) {
        Logger.log('Handle message: ' + JSON.stringify(message));
        dispatch(store, { command: message.command, data: message.data });
    }
}

(function () {
    // make class public
    window.OPLWCChild = new OPLWCChild();
})();
